import { Box } from "@mui/material";
import React from "react";

interface MyComponentProps {
    children?: React.ReactNode;
    index: number;
    value: number;
    width?: string;
}


const TabPanel: React.FC<MyComponentProps> = (props) => {
    const { children, value, index, width, ...other } = props;

    return (
      <Box
          sx={{
              width: width? width : "100%",
           }}
        role="tabpanel"
        hidden={value !== index}
        id={`vertical-tabpanel-${index}`}
        aria-labelledby={`vertical-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{  }}>
            {children}
          </Box>
        )}
      </Box>
    );
}

export function a11yProps(index: number) {
    return {
        id: `vertical-tab-${index}`,
        'aria-controls': `vertical-tabpanel-${index}`,
    };
}

export default TabPanel